// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageNotFound_wrapper__1Zhjj","buttonsRow":"PageNotFound_buttonsRow__1DtKj"};